import React, { useEffect } from "react";
import "./ImageModal.scss";

type ImageModalProps = {
    src: string;
    alt?: string;
    onClose: () => void;
};

const ImageModal: React.FC<ImageModalProps> = ({ src, alt, onClose }) => {
    // close on ESC
    useEffect(() => {
        const handleKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [onClose]);

    return (
        <div className="image-modal-overlay" onClick={onClose}>
            <div
                className="image-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    className="image-modal-close"
                    onClick={onClose}
                    aria-label="Close image"
                >
                    ✕
                </button>

                <img src={src} alt={alt ?? "Preview"} />
            </div>
        </div>
    );
};

export default ImageModal;